'use client';

import { BannerCampaignSection } from '@/components/banner/banner-campaign-section';
import { FeaturedMoviesCarouselComponent } from '@/components/featured-movies-carousel/featured-movies-carousel';
import { LoadingSpinnerComponent } from '@/components/loading-spinner/loading-spinner';
import { PromotionalContent } from '@/components/promotional-content/promotional-content';
import { AnalyticsPageCategories } from '@/enums/analytics-type';
import { PromotionalContentPlacement } from '@/enums/promotional-content-placement';
import { BannerCampaign, Movie, PromoContentRelationshipType } from '@cinemark/content-api-client';
import dynamic from 'next/dynamic';
import { MovieDetailCast } from './components/movie-detail-cast';
import { MovieDetailInfo } from './components/movie-detail-info';
import { MovieDetailMedia } from './components/movie-detail-media';

const MovieShowtimesLoading = (): React.JSX.Element =>
  <div className="flex justify-center py-lg">
    <LoadingSpinnerComponent center="within" />
  </div>
;

const MovieShowtimesListView = dynamic(
  () => import('@/components/showtimes/movie-showtimes-list-view').then(m => m.MovieShowtimesListView),
  { loading: MovieShowtimesLoading, ssr: false }
);

type MovieDetailViewProps = {
  bannerCampaign?: BannerCampaign | null;
  movie: Movie;
};

const movieDetailsCategory = AnalyticsPageCategories.MOVIE_DETAIL;

export const MovieDetailView = ({ bannerCampaign, movie }: Readonly<MovieDetailViewProps>): React.JSX.Element => {
  return (
    <div className="flex flex-col gap-md md:pt-md">
      <div className="w-full flex flex-col gap-md">
        <div className="container-lg hug w-full flex flex-col">
          <MovieDetailMedia dataLinkCategory={movieDetailsCategory}
            movie={movie}
          />
        </div>
        <div className="container-lg hug flex flex-col gap-md w-full *:min-md:max-w-[900px] *:min-md:self-center *:max-md:px-ms">
          <MovieDetailInfo movie={movie} />
          <MovieDetailCast dataLinkCategory={movieDetailsCategory}
            movie={movie}
          />
          <PromotionalContent dataLinkCategory={movieDetailsCategory}
            numberOfItemsToShow={1}
            placement={PromotionalContentPlacement.MidContent}
            promoContentRelationshipType={PromoContentRelationshipType.Movie}
            relationId={movie.id}
          />
          <MovieShowtimesListView dataLinkCategory={movieDetailsCategory}
            movieId={movie.cinemarkMovieId}
          />
          <BannerCampaignSection bannerCampaign={bannerCampaign}
            bannerType="bannerTiles"
            dataLinkCategory={movieDetailsCategory}
          />
          <FeaturedMoviesCarouselComponent className="max-w-[840px]"
            dataLinkCategory={movieDetailsCategory}
            title="You Might Also Like"
          />
        </div>
      </div>
    </div>
  );
};
